<template>
  <button
    role="button"
    class="relative flex rounded-full text-base text-header-icon items-center"
    :aria-label="$t('Shopping cart')">
    <ShoppingCartIcon class="h-6 my-2" />
    <template v-if="count">
      <div
        v-if="count"
        class="absolute bottom-3 left-3 font-bold bg-red-600 text-white flex justify-center items-center rounded-full size-5 px-1 border-2 border-background"
        style="font-size: 12px">
        {{ count }}
      </div>
    </template>
  </button>
</template>

<script setup>
defineProps({
  count: { required: true },
  items: { required: true },
});
import { ShoppingCartIcon } from "@heroicons/vue/24/outline";
</script>

<style scoped></style>
